import { Injectable, APP_INITIALIZER } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class ConfigService {

  public _config: Object;

  constructor(private http: Http) { }

  loadAppConfig() {
    return new Promise((resolve, reject) => {
      this.http.get('./assets/config.json')
        .toPromise()
        .then(data => {
          this._config = data.json();
          resolve(true);
        }, err => {
          console.log('config not found');
        });
    });
  }
  get(key: any) {
    return this._config[key];
  }
}
export function ConfigFactory(config: ConfigService) {
  return () => config.loadAppConfig();
}
export function init() {
  return {
    provide: APP_INITIALIZER,
    useFactory: ConfigFactory,
    deps: [ConfigService],
    multi: true
  }
}
const ConfigModule = {
  init: init
}
export { ConfigModule };



// WEBPACK FOOTER //
// ./src/app/services/config.service.ts